import {FC} from 'react';

import {DocumentCodesFormModal} from 'components/ais/document-codes/components/document-codes-form-modal/document-codes-form-modal';
import {DocumentComparisonModal} from 'components/document-comparison-modal';
import {DocumentsFileUploadModal} from 'components/documents/file-modal';
import {DocumentsUploadStageModal} from 'components/documents/file-modal/upload-stage-modal';
import {DocumentsSignatureUploadModal} from 'components/documents/signature-modal';
import {EditableTableModal} from 'components/editable-table-modal';
import {FilterDrawer} from 'components/filter-drawer';
import {FilterModal} from 'components/filter-modal';
import {FormDrawer} from 'components/form-drawer';
import {FormEditEntityModal} from 'components/form-edit-modal';
import {FormModal} from 'components/form-modal';
import {ListGridModal} from 'components/list-grid-modal';
import {ListModal} from 'components/list-modal';
import {RequestFormModal} from 'components/request/request-form-modal';

import {TModalComponentInterface, EModalType} from '../../store/slices/modals-slice/modals-slice-types';
import {
    SettingProgramMappingModal,
} from '../settings-programs/components/setting-program-mapping-modal/setting-program-mapping-modal';

export const AppModalsMapping: Record<string, FC<TModalComponentInterface>> = {
    [EModalType.documentsFileUpload]: DocumentsFileUploadModal,
    [EModalType.documentsUploadStage]: DocumentsUploadStageModal,
    [EModalType.documentsSignatureUpload]: DocumentsSignatureUploadModal,
    [EModalType.editableTableModal]: EditableTableModal,
    // TODO убрать formCreateItem после обновления metatable
    [EModalType.formCreateItem]: FormModal,
    [EModalType.formModal]: FormModal,
    [EModalType.formDrawer]: FormDrawer,
    [EModalType.filterDrawer]: FilterDrawer,
    [EModalType.formEditEntityModal]: FormEditEntityModal,
    [EModalType.filterModal]: FilterModal,
    [EModalType.listModal]: ListModal,
    [EModalType.listGridModal]: ListGridModal,
    [EModalType.documentComparisonModal]: DocumentComparisonModal,
    [EModalType.requestFormModal]: RequestFormModal,
    [EModalType.documentCodesFormModal]: DocumentCodesFormModal,
    [EModalType.settingProgramMappingModal]: SettingProgramMappingModal,
};
